import component from './Jumbotron'

export default component
